//hooks
import { useState, useEffect } from "react";
import { useApi } from "../hooks/useApi";

//mui
import { Box } from "@mui/material"
import CircularProgress from '@mui/material/CircularProgress';
import ReplayIcon from '@mui/icons-material/Replay';

//material ui icons
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import FacebookIcon from '@mui/icons-material/Facebook';

//translate
import { useTranslation } from 'react-i18next';
import i18n from "../translate/i18n";

//react-router
import { Link } from 'react-router-dom';

//api
import { GetSettings } from "../api/setting/GetSettings";

//type
import { settingsTypeRes } from "../api/setting/type/SettingsType";

const params  = [
    "social.instagram",
    "social.facebook",
    "social.x",
]

const Footer = () => {
  const { t } = useTranslation();
  const [contactSection, setContactSection] = useState<settingsTypeRes[]>([]);
  const {
      loading: contactLoading,
      error: contactError,
      HandlerApi: contactApi
  } = useApi(GetSettings, "GET");

  useEffect(() => {
      const fetchData = async () => {
      const contactData = await contactApi(params);
      setContactSection(contactData.data);
      };
      fetchData();
      }, []);
  return (
    <div dir={i18n.language === "en" ? "ltr" : "rtl"} className={`${i18n.language === "en" ? "font-palab" : "font-helvetica-arabic-light"} bg-primaryColor`}>
      <Box sx={{padding: {md: "40px", xs: "20px"}}} className="max-w-[1560px] m-auto">
        <div className="grid lg:grid-cols-4 grid-cols-2 max-lg:w-fit max-lg:m-auto gap-10">
            <div>
              <div className="flex gap-3 max-lg:justify-center">
                <div className="p-2 flex justify-center items-center bg-yellow-500 rounded-full w-[30px] h-[30px]">
                  <p>C</p>
                </div>
                <div>
                  <h2 className="text-white">{t("cham_hotel")}</h2>
                  <p className="text-[#d7d6ac] text-[12px]">{t("damascus_heritage")}</p>
                </div>
              </div>
              <p className="text-[#d7d6ac] text-[12px] max-w-[290px] mt-5 max-lg:text-center">{t("footer_text1")}</p>
            </div>
            <div className="max-lg:text-center">
              <h2 className="text-white">{t("quick_links")}</h2>
              <ul className="text-[#d7d6ac] text-[12px] flex flex-col gap-2 mt-5">
                  <li>
                    <Link to="/"> {t("home")}</Link>
                  </li>
                  <li>
                      <Link to="/about">{t("about")}</Link>
                  </li>
                  <li>
                      <Link to="/contact"> {t("contact")}</Link>
                  </li>
              </ul>
            </div>
            <div className="max-lg:text-center">
              <h2 className="text-white">{t("services")}</h2>
              <ul className="text-[#d7d6ac] text-[12px] flex flex-col gap-2 mt-5">
                  <li>
                    <Link to="/rooms">{t("rooms")}</Link>
                  </li>
                  <li>
                      <Link to="/amenities">{t("amenities")}</Link>
                  </li>
                  <li>
                    <Link to="/gallery">{t("gallery")}</Link>
                  </li>
              </ul>
            </div>
            <div className="max-lg:text-center">
              <h2 className="text-white">{t("follow_us")}</h2>
            {contactLoading 
            ? 
            <div className='flex justify-center w-full'>
                <CircularProgress className='!text-white'/>
            </div>
            :
            contactError
            ?
            <div className='cursor-pointer flex justify-center w-full'>
                <ReplayIcon onClick={() => contactApi(params)} className='!text-[40px] !text-white' />
            </div>
            :
            <>
              <ul className="text-[#d7d6ac] text-[12px] flex gap-2 mt-5 max-lg:justify-center">
              {contactSection.map((element, index) => {
                if (element.key === "social.instagram") {
                  return (
                    <li key={index}>
                      <a href={element.value} target="_blank" rel="noopener noreferrer">
                        <InstagramIcon/>
                      </a>
                    </li>
                  )
                } else if (element.key === "social.facebook") {
                  return (
                    <li key={index}>
                      <a href={element.value} target="_blank" rel="noopener noreferrer">
                        <FacebookIcon/>
                      </a>
                    </li>
                  )
                }
                else if (element.key === "social.x") {
                  return (
                    <li key={index}>
                      <a href={element.value} target="_blank" rel="noopener noreferrer">
                        <XIcon/>
                      </a>
                    </li>
                  )
                }
              })}
              </ul>
            </>
            }
              <p className="mt-2 text-[#d7d6ac] text-[12px]">{t("footer_text2")}</p>
            </div>
        </div>
        <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
        <div className="flex items-center sm:justify-between max-md:flex-col max-md:gap-2 text-[#d7d6ac] max-sm:text-[12px]">
            <span className="max-md:order-2">
              © {new Date().getFullYear()} {t("right_reserved")}
            </span>
            <div className="flex gap-5 max-md:order-1">
              <Link to="/privacy">{t("privacy_policy")}</Link>
                <Link to="/terms">{t("terms_of_service")}</Link>
            </div>
        </div>
      </Box>
    </div>
  )
}

export default Footer
